import React from 'react'
import { Grid, Typography } from '@mui/material'
import { dsColorNew } from '@palette'

import {OfficesAutocomplete, NoDataFound, AppOfficesAutocomplete, AppTableSkeleton } from '@components'
import ReportListHistoricalModalContentTable from './Table'
import { useInfoModalHistorical } from 'Pages/ReportsAlerts/Reports/@hooks'
import {BACKEND_APIS} from "../../../../../../../@constants";


export default function ReportInfoModalHistoricalContent({ id_report, rowData }) {
	const {
		offices, officeSelected, setOfficeSelected, numOffices, isLoadingHistoricalData, reportName, historicalOfficeData, officeOptions, idLastExecution
	} = useInfoModalHistorical(id_report, rowData)

	return <Grid container spacing={2}>
		<Grid item xs={6}>
			<AppOfficesAutocomplete
				onFinishAjax={opts => officeOptions.value = opts}
				options={officeOptions.value}
				value={officeSelected}
				onChange={e => setOfficeSelected(e.target.value)}
				disabled={numOffices === 1}
				urlAjax={`${BACKEND_APIS.EXECUTION_INFO}/offices`}
				filters={{
					idReportExecution: idLastExecution,
					noFilterStatus: true
				}}
			/>
		</Grid>

		<Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
			{!isLoadingHistoricalData && !!historicalOfficeData.length && <Typography sx={{ fontSize: 13, color: dsColorNew.textMuted }}>
				{historicalOfficeData.length} execution{historicalOfficeData.length === 1 ? '' : 's'}
			</Typography>}
		</Grid>

		{!!isLoadingHistoricalData && <Grid item xs={12}>
			<AppTableSkeleton rows={5} columns={6}/>
		</Grid>}

		{!isLoadingHistoricalData && !officeSelected && !historicalOfficeData.length && <Grid item xs={12}>
			<NoDataFound />
		</Grid>
		}

		{!isLoadingHistoricalData && !!historicalOfficeData.length && <Grid item xs={12}>
			<ReportListHistoricalModalContentTable
				reportName={reportName}
				pickUp={offices}
				data={historicalOfficeData}
				hasCompetitionSites={rowData.hasCompetitionSites}
				hasDirectSites={rowData.hasDirectSites}
				hasGenerate={rowData.generate}
				hasExport={rowData.export}
				isRunning={rowData.statusLastExecution === "running"}
				officeSelected={officeSelected}
			/>
		</Grid>}
	</Grid>
}